(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["meriphora-card-linked-color-swatches"] && !Shopify.designMode) return;
  try {
    class MeriphoraCardLinkedColorSwatches extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick, { capture: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick, { capture: true });
    }

    handleClick = (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-meriphora-card-swatch-link]') : null;

      if (!(link instanceof HTMLAnchorElement)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (link.classList.contains('is-selected')) return;

      this.updateProductCard(link);
    };

    updateProductCard(link) {
      const card = this.closest('product-card');
      if (!card) return;

      const productUrl = link.dataset.productUrl || link.href;
      const productId = link.dataset.productId || '';
      const productTitle = link.dataset.productTitle || link.getAttribute('aria-label') || '';
      const variantId = link.dataset.variantId || '';

      this.updateSelectedSwatch(link);
      this.updateCardLinks(card, productUrl, productTitle);
      this.updateCardImage(card, link, productTitle);
      this.updateCardTitle(card, productTitle);
      this.updateCardPrice(card, productId);
      this.updateQuickAdd(card, link, productId, productTitle, variantId);

      if (productId) {
        card.setAttribute('data-product-id', productId);
        card.closest('[data-product-id]')?.setAttribute('data-product-id', productId);
      }
    }

    updateSelectedSwatch(selectedLink) {
      this.querySelectorAll('[data-meriphora-card-swatch-link]').forEach((link) => {
        const isSelected = link === selectedLink;
        link.classList.toggle('is-selected', isSelected);

        if (isSelected) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    updateCardLinks(card, productUrl, productTitle) {
      card.querySelectorAll('a[ref="productCardLink"], a[ref="cardGalleryLink"], a[ref="productTitleLink"]').forEach((anchor) => {
        if (!(anchor instanceof HTMLAnchorElement)) return;

        anchor.href = productUrl;

        if (anchor.matches('[ref="cardGalleryLink"]')) {
          anchor.setAttribute('aria-label', productTitle);
        }
      });

      const hiddenTitle = card.querySelector('a[ref="productCardLink"] .visually-hidden');
      if (hiddenTitle) hiddenTitle.textContent = productTitle;
    }

    updateCardImage(card, link, productTitle) {
      const imageUrl = link.dataset.imageUrl;
      const imageAlt = link.dataset.imageAlt || productTitle;
      const mediaId = link.dataset.mediaId;
      const featuredMediaUrl = link.dataset.featuredMediaUrl;
      const images = this.getProductImages(link.dataset.productId || '');

      if (featuredMediaUrl) {
        card.setAttribute('data-featured-media-url', featuredMediaUrl);
      }

      const gallery = card.querySelector('.card-gallery');
      if (gallery && link.dataset.productId) {
        gallery.setAttribute('data-product-id', link.dataset.productId);
      }

      const cardImages = card.querySelectorAll('.card-gallery .product-media__image');

      if (!cardImages.length || (!imageUrl && !images.length)) return;

      cardImages.forEach((image, index) => {
        if (!(image instanceof HTMLImageElement)) return;

        const imageData = images[index] || images[0];
        const nextImageUrl = imageData?.url || imageUrl;
        if (!nextImageUrl) return;

        image.src = nextImageUrl;
        image.removeAttribute('srcset');
        image.alt = imageData?.alt || imageAlt;

        const productMedia = image.closest('.product-media');
        if (productMedia) {
          productMedia.setAttribute('data-media-id', imageData?.mediaId || mediaId || '');

          if (imageData?.aspectRatio) {
            productMedia.style.setProperty('--ratio', imageData.aspectRatio);
          }
        }
      });
    }

    updateCardTitle(card, productTitle) {
      const titleLink = card.querySelector('a[ref="productTitleLink"]');
      const titleElement = titleLink?.querySelector('[role="heading"], .title-text, h1, h2, h3, h4, h5, h6, p');

      if (titleElement) {
        titleElement.textContent = productTitle;
      }
    }

    updateCardPrice(card, productId) {
      if (!productId) return;

      const priceTemplate = this.querySelector(`template[data-meriphora-card-price-template="${productId}"]`);
      const productPrice = card.querySelector('product-price');

      if (!(priceTemplate instanceof HTMLTemplateElement) || !productPrice) return;

      productPrice.innerHTML = priceTemplate.innerHTML;
      productPrice.setAttribute('data-product-id', productId);
    }

    updateQuickAdd(card, link, productId, productTitle, variantId) {
      const quickAdd = card.querySelector('quick-add-component');
      const productForm = quickAdd?.querySelector('product-form-component');
      const variantInput = quickAdd?.querySelector('input[name="id"]');
      const meriphoraQuickAdd = card.querySelector('meriphora-card-quick-add');

      if (quickAdd) {
        quickAdd.setAttribute('data-product-title', productTitle);
        quickAdd.setAttribute('data-quick-add-button', link.dataset.quickAddButton || 'choose');
      }

      if (productForm && productId) {
        productForm.setAttribute('data-product-id', productId);
      }

      if (variantInput instanceof HTMLInputElement && variantId) {
        variantInput.value = variantId;
        variantInput.disabled = false;
      }

      if (meriphoraQuickAdd instanceof HTMLElement && productId) {
        meriphoraQuickAdd.setAttribute('data-product-id', productId);
        meriphoraQuickAdd.setAttribute('data-default-variant-id', variantId);
        meriphoraQuickAdd.dispatchEvent(
          new CustomEvent('meriphora:quick-add-product-change', {
            bubbles: false,
            detail: { productId, variantId },
          })
        );
      }
    }

    getProductImages(productId) {
      if (!productId) return [];

      const imagesTemplate = this.querySelector(`template[data-meriphora-card-images-template="${productId}"]`);
      if (!(imagesTemplate instanceof HTMLTemplateElement)) return [];

      try {
        const images = JSON.parse(imagesTemplate.content.textContent || '[]');
        return Array.isArray(images) ? images : [];
      } catch (error) {
        console.warn('Could not parse Meriphora card swatch images', error);
        return [];
      }
    }
  }

  if (!customElements.get('meriphora-card-linked-color-swatches')) {
    customElements.define('meriphora-card-linked-color-swatches', MeriphoraCardLinkedColorSwatches);
  }
  } catch(e) { console.error(e); }
})();

})();
